'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _NewMedicalApplicationModal = require('./NewMedicalApplicationModal');

var _NewMedicalApplicationModal2 = _interopRequireDefault(_NewMedicalApplicationModal);

var _NewPlaintiffApplicationModal = require('./NewPlaintiffApplicationModal');

var _NewPlaintiffApplicationModal2 = _interopRequireDefault(_NewPlaintiffApplicationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var NewApplicationButtons = (_dec = (0, _mobxReact.inject)('UiStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(NewApplicationButtons, _Component);

  function NewApplicationButtons() {
    _classCallCheck(this, NewApplicationButtons);

    return _possibleConstructorReturn(this, (NewApplicationButtons.__proto__ || Object.getPrototypeOf(NewApplicationButtons)).apply(this, arguments));
  }

  _createClass(NewApplicationButtons, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _case = _props._case,
          UiStore = _props.UiStore,
          _props$FunderStore = _props.FunderStore,
          doesMedicalFunding = _props$FunderStore.doesMedicalFunding,
          doesPlaintiffFunding = _props$FunderStore.doesPlaintiffFunding,
          _UiStore$modals = UiStore.modals,
          NewMedicalApplication = _UiStore$modals.NewMedicalApplication,
          NewPlaintiffApplication = _UiStore$modals.NewPlaintiffApplication,
          doesBoth = doesMedicalFunding && doesPlaintiffFunding;


      return _react2.default.createElement(
        'div',
        { className: 'buttons' },
        doesPlaintiffFunding && _react2.default.createElement(
          _Button2.default,
          { bsSize: 'small', onClick: NewPlaintiffApplication.open },
          'New ',
          doesBoth && 'Plaintiff Funding',
          ' Application'
        ),
        doesMedicalFunding && _react2.default.createElement(
          _Button2.default,
          { bsSize: 'small', onClick: NewMedicalApplication.open },
          'New ',
          doesBoth && 'Medical',
          ' Application'
        ),
        NewPlaintiffApplication.showing() && _react2.default.createElement(_NewPlaintiffApplicationModal2.default, { _case: _case }),
        NewMedicalApplication.showing() && _react2.default.createElement(_NewMedicalApplicationModal2.default, { _case: _case })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NewApplicationButtons;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = NewApplicationButtons;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NewApplicationButtons, 'NewApplicationButtons', '/app/src/components/page-case/main-applications/NewApplicationButtons.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/NewApplicationButtons.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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